<!--  -->
<template>
  <div class="header df-between" id='header' :style="{'padding-top':utils.isIphoneX()?'50px':'30px','background-color': bgColor}">
    <i @click="handleBack()" class="back" v-if="isBack"></i>
    <!-- <img src="../../assets/images/i-arrow-left.png" alt="" class="back" > -->
    <div class='title'>{{headTitle}}</div>
    <div class="right-title" v-if="rightTitle" @click="rightTileClick">{{rightTitle}}</div>
    <i class='iconfont' v-else></i>
  </div>
</template>

<script>
  export default {
    props:{
      headTitle:{// 标题名称
        type:String,
        default:''
      },
      isBack:{ //是否返回
        type:Boolean,
        default:true
      },
      pageName:{ //页面名称
        type:String,
        default:''
      },
      // comeFrom:{ //来源名称
      //   type:String,
      //   default:''
      // },
      bgColor: {
        type: String,
        default: '#fff'
      },
      rightTitle: {
        type: String,
        default: ''
      },
      showRightTile: {
        type: Boolean,
        default: false
      },
      isForbidBack: { // 禁止返回
        type: Boolean,
        default: false
      },
      goApp: { // 跳转到app
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        headerHeight:'',
      }
    },
    created() {},
    mounted(){
      this.headerHeight = document.getElementById('header').offsetHeight
      this.$emit('getHeaderHeight',this.headerHeight)
    },
    methods: {
      handleBack(){
        if(this.isBack && !this.isForbidBack&&!this.goApp){
          this.$router.go(-1)
        } else {
          this.$emit('back')
        }
      },
      rightTileClick() {
          this.$emit('rightClick')
      }
    },
  }
</script>
<style lang='scss' scoped>
  .header {
    padding: 15px;
    font-size: 17px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #000000;
    .title{
      width: 80%;
      font-size: 17px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
      text-align: center;
    }
    .back {
      width: 22px;
      height: 22px;
      background: url('../../assets/images/i-arrow-left.png');
      background-size: 100% 100%;
    }
  }
</style>
